module.exports = __webpack_public_path__ + "img/tv.7e7cada7.svg";